import BGCForm from './bgc-form'
import BGCInfoPreview from './bgc-info-preview'

export { BGCForm, BGCInfoPreview }
